import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { A11yModule, FocusTrapFactory } from '@angular/cdk/a11y';
import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { TemplateRef, Component, Inject, ViewChild, ViewContainerRef, HostBinding, HostListener, EventEmitter, Input, Output, Directive, ElementRef, Injectable, NgModule, ɵɵdefineInjectable, ɵɵinject, INJECTOR, Injector } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule, MAT_BOTTOM_SHEET_DEFAULT_OPTIONS, MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule, MAT_EXPANSION_PANEL_DEFAULT_OPTIONS } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconRegistry, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { timer, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { OverlayRef, Overlay } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/snack-bar';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/button';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/cdk/stepper';
import * as ɵngcc6 from '@angular/router';
import * as ɵngcc7 from '@angular/platform-browser';
import * as ɵngcc8 from '@angular/material/bottom-sheet';
import * as ɵngcc9 from '@angular/cdk/overlay';
import * as ɵngcc10 from '@angular/cdk/a11y';

const _c0 = ["customTemplateContainer"];
function CustomSnackbarComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.getMessageString(), ɵngcc0.ɵɵsanitizeHtml);
} }
function CustomSnackbarComponent_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 5);
    ɵngcc0.ɵɵlistener("click", function CustomSnackbarComponent_button_4_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.dismiss(); });
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 6);
    ɵngcc0.ɵɵtext(2, "close");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} }
function HorizontalStepperComponent_div_0_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 8);
} }
const _c1 = function (a0) { return { selected: a0 }; };
function HorizontalStepperComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, HorizontalStepperComponent_div_0_ng_container_1_div_1_Template, 1, 0, "div", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵlistener("click", function HorizontalStepperComponent_div_0_ng_container_1_Template_div_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const i_r3 = ctx.index; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); ctx_r5.selectedIndex = i_r3; return ctx_r5.breadcrumbClicked.emit({ event: $event, index: i_r3 }); })("keydown.enter", function HorizontalStepperComponent_div_0_ng_container_1_Template_div_keydown_enter_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const i_r3 = ctx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.selectedIndex = i_r3; });
    ɵngcc0.ɵɵelementStart(3, "mat-icon", 7);
    ɵngcc0.ɵɵtext(4, "check");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const step_r2 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", i_r3 > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c1, ctx_r1.selectedIndex === i_r3));
    ɵngcc0.ɵɵattribute("aria-label", "navigate to step " + (i_r3 + 1) + ", " + step_r2.label);
} }
function HorizontalStepperComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtemplate(1, HorizontalStepperComponent_div_0_ng_container_1_Template, 5, 5, "ng-container", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.atBottom ? "footer" : "nav");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.steps);
} }
var AlertType;
(function (AlertType) {
    AlertType["Error"] = "error";
    AlertType["Info"] = "info";
    AlertType["Warn"] = "warn";
})(AlertType || (AlertType = {}));
class Alert {
    constructor() {
        this.type = AlertType.Info;
    }
}
class CustomSnackbarComponent {
    constructor(snackbarRef, data) {
        this.snackbarRef = snackbarRef;
        this.data = data;
        this.dismissSnackbar = false;
        if (data.duration) {
            timer(data.duration - 10)
                .pipe(take(1))
                .subscribe(() => this.dismiss());
        }
    }
    get isInfo() {
        return this.data.type === AlertType.Info;
    }
    get isError() {
        return this.data.type === AlertType.Error;
    }
    get isWarn() {
        return this.data.type === AlertType.Warn;
    }
    get snackbarClosed() {
        return this.dismissSnackbar;
    }
    onAnimationEnd(e) {
        if (this.dismissSnackbar) {
            this.snackbarRef.dismiss();
        }
    }
    ngAfterViewInit() {
        if (this.hasCustomTemplate()) {
            this.customTemplateContainer.createEmbeddedView(this.data.message);
        }
    }
    getMessageString() {
        return this.data.message instanceof TemplateRef ? '' : `${this.data.message}`;
    }
    hasCustomTemplate() {
        return this.data.message instanceof TemplateRef;
    }
    dismiss() {
        this.dismissSnackbar = true;
    }
}
CustomSnackbarComponent.ɵfac = function CustomSnackbarComponent_Factory(t) { return new (t || CustomSnackbarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MatSnackBarRef), ɵngcc0.ɵɵdirectiveInject(MAT_SNACK_BAR_DATA)); };
CustomSnackbarComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: CustomSnackbarComponent, selectors: [["livesafe-mat-custom-snackbar"]], viewQuery: function CustomSnackbarComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true, ViewContainerRef);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customTemplateContainer = _t.first);
    } }, hostVars: 8, hostBindings: function CustomSnackbarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("animationend", function CustomSnackbarComponent_animationend_HostBindingHandler($event) { return ctx.onAnimationEnd($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("info", ctx.isInfo)("error", ctx.isError)("background-background-1000", ctx.isWarn)("dismiss", ctx.snackbarClosed);
    } }, decls: 5, vars: 2, consts: [[1, "message"], [4, "ngIf"], ["customTemplateContainer", ""], ["livesafeMat", "", "mat-icon-button", "", "class", "close-button", "aria-label", "close alert", 3, "click", 4, "ngIf"], [3, "innerHTML"], ["livesafeMat", "", "mat-icon-button", "", "aria-label", "close alert", 1, "close-button", 3, "click"], ["livesafeMat", "", "size", "small", "fontSet", "material-icons-round"]], template: function CustomSnackbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span", 0);
        ɵngcc0.ɵɵtemplate(1, CustomSnackbarComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementContainer(2, null, 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, CustomSnackbarComponent_button_4_Template, 3, 0, "button", 3);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hasCustomTemplate());
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.data.isDismissible);
    } }, directives: function () { return [ɵngcc2.NgIf, ɵngcc3.MatButton, LiveSafeMatDirective, ɵngcc4.MatIcon]; }, styles: ["@font-face{font-family:Inter;font-style:normal;font-weight:400;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Bold;font-style:normal;font-weight:700;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Semi Bold;font-style:normal;font-weight:500;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}[_nghost-%COMP%]{-webkit-animation:slide-up .5s cubic-bezier(.25,.46,.45,.94) both;align-items:center;animation:slide-up .5s cubic-bezier(.25,.46,.45,.94) both;color:#fff;display:flex;font-weight:700;height:47px;justify-content:center;padding:13px 20px}.info[_nghost-%COMP%]{background:linear-gradient(90deg,#6de1f7,#30b9da)}.error[_nghost-%COMP%]{background:linear-gradient(90deg,#ff8e8a,#fe6d69)}.dismiss[_nghost-%COMP%]{-webkit-animation:slide-down .5s cubic-bezier(.25,.46,.45,.94) both;animation:slide-down .5s cubic-bezier(.25,.46,.45,.94) both}.message[_ngcontent-%COMP%]{flex-grow:1;text-align:center}.close-button[_ngcontent-%COMP%]:hover{color:#fff}  .highlight{align-items:center;background-color:#fff;border-radius:4px;box-shadow:0 13px 40px 0 rgba(22,32,38,.12);color:#4f5868;display:inline-flex;font-weight:700;height:22px;line-height:22px;margin:0 6px;padding:2px 5px;text-align:center}@-webkit-keyframes slide-up{0%{transform:translateY(100px)}to{transform:translateY(0)}}@keyframes slide-up{0%{transform:translateY(100px)}to{transform:translateY(0)}}@-webkit-keyframes slide-down{0%{transform:translateY(0)}to{transform:translateY(100px)}}@keyframes slide-down{0%{transform:translateY(0)}to{transform:translateY(100px)}}"] });
CustomSnackbarComponent.ctorParameters = () => [
    { type: MatSnackBarRef },
    { type: Alert, decorators: [{ type: Inject, args: [MAT_SNACK_BAR_DATA,] }] }
];
CustomSnackbarComponent.propDecorators = {
    customTemplateContainer: [{ type: ViewChild, args: ['customTemplateContainer', { read: ViewContainerRef },] }],
    isInfo: [{ type: HostBinding, args: ['class.info',] }],
    isError: [{ type: HostBinding, args: ['class.error',] }],
    isWarn: [{ type: HostBinding, args: ['class.background-background-1000',] }],
    snackbarClosed: [{ type: HostBinding, args: ['class.dismiss',] }],
    onAnimationEnd: [{ type: HostListener, args: ['animationend', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(CustomSnackbarComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-mat-custom-snackbar',
                template: "<span class=\"message\">\n  <ng-container *ngIf=\"!hasCustomTemplate()\">\n    <span [innerHTML]=\"getMessageString()\"></span>\n  </ng-container>\n  <ng-container #customTemplateContainer></ng-container>\n</span>\n<button\n  livesafeMat\n  *ngIf=\"data.isDismissible\"\n  mat-icon-button\n  class=\"close-button\"\n  aria-label=\"close alert\"\n  (click)=\"dismiss()\"\n>\n  <mat-icon livesafeMat size=\"small\" fontSet=\"material-icons-round\">close</mat-icon>\n</button>\n",
                styles: ["@font-face{font-family:Inter;font-style:normal;font-weight:400;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Bold;font-style:normal;font-weight:700;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Semi Bold;font-style:normal;font-weight:500;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}:host{-webkit-animation:slide-up .5s cubic-bezier(.25,.46,.45,.94) both;align-items:center;animation:slide-up .5s cubic-bezier(.25,.46,.45,.94) both;color:#fff;display:flex;font-weight:700;height:47px;justify-content:center;padding:13px 20px}:host.info{background:linear-gradient(90deg,#6de1f7,#30b9da)}:host.error{background:linear-gradient(90deg,#ff8e8a,#fe6d69)}:host.dismiss{-webkit-animation:slide-down .5s cubic-bezier(.25,.46,.45,.94) both;animation:slide-down .5s cubic-bezier(.25,.46,.45,.94) both}.message{flex-grow:1;text-align:center}.close-button:hover{color:#fff}::ng-deep .highlight{align-items:center;background-color:#fff;border-radius:4px;box-shadow:0 13px 40px 0 rgba(22,32,38,.12);color:#4f5868;display:inline-flex;font-weight:700;height:22px;line-height:22px;margin:0 6px;padding:2px 5px;text-align:center}@-webkit-keyframes slide-up{0%{transform:translateY(100px)}to{transform:translateY(0)}}@keyframes slide-up{0%{transform:translateY(100px)}to{transform:translateY(0)}}@-webkit-keyframes slide-down{0%{transform:translateY(0)}to{transform:translateY(100px)}}@keyframes slide-down{0%{transform:translateY(0)}to{transform:translateY(100px)}}"]
            }]
    }], function () { return [{ type: ɵngcc1.MatSnackBarRef }, { type: Alert, decorators: [{
                type: Inject,
                args: [MAT_SNACK_BAR_DATA]
            }] }]; }, { isInfo: [{
            type: HostBinding,
            args: ['class.info']
        }], isError: [{
            type: HostBinding,
            args: ['class.error']
        }], isWarn: [{
            type: HostBinding,
            args: ['class.background-background-1000']
        }], snackbarClosed: [{
            type: HostBinding,
            args: ['class.dismiss']
        }], onAnimationEnd: [{
            type: HostListener,
            args: ['animationend', ['$event']]
        }], customTemplateContainer: [{
            type: ViewChild,
            args: ['customTemplateContainer', { read: ViewContainerRef }]
        }] }); })();

class HorizontalStepperComponent extends CdkStepper {
    constructor() {
        super(...arguments);
        this.showNav = true;
        this.atBottom = false;
        this.breadcrumbClicked = new EventEmitter();
    }
}
HorizontalStepperComponent.ɵfac = function HorizontalStepperComponent_Factory(t) { return ɵHorizontalStepperComponent_BaseFactory(t || HorizontalStepperComponent); };
HorizontalStepperComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: HorizontalStepperComponent, selectors: [["livesafe-mat-horizontal-stepper"]], inputs: { showNav: "showNav", atBottom: "atBottom" }, outputs: { breadcrumbClicked: "breadcrumbClicked" }, features: [ɵngcc0.ɵɵProvidersFeature([{ provide: CdkStepper, useExisting: HorizontalStepperComponent }]), ɵngcc0.ɵɵInheritDefinitionFeature], decls: 4, vars: 3, consts: [["class", "d-f ai-c jc-c", "s", "", 3, "ngClass", 4, "ngIf"], [1, "body"], [3, "ngTemplateOutlet"], ["s", "", 1, "d-f", "ai-c", "jc-c", 3, "ngClass"], [4, "ngFor", "ngForOf"], ["class", "connector", 4, "ngIf"], ["tabindex", "0", "role", "button", 1, "bread-crumb", 3, "ngClass", "click", "keydown.enter"], [1, "c-dewgong"], [1, "connector"]], template: function HorizontalStepperComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HorizontalStepperComponent_div_0_Template, 2, 2, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementContainer(2, 2);
        ɵngcc0.ɵɵelementContainer(3, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNav);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.selected == null ? null : ctx.selected.stepLabel == null ? null : ctx.selected.stepLabel.template);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.selected == null ? null : ctx.selected.content);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgTemplateOutlet, ɵngcc2.NgClass, ɵngcc2.NgForOf, ɵngcc4.MatIcon], styles: ["[_nghost-%COMP%]{display:block}.nav[_ngcontent-%COMP%]{margin-bottom:40px}.footer[_ngcontent-%COMP%]{background-color:#fff;bottom:0;height:70px;left:0;margin-bottom:0;position:fixed;right:0;z-index:100}.bread-crumb[_ngcontent-%COMP%]{align-items:center;background:linear-gradient(90deg,#6de1f7,#30b9da);border-radius:100%;display:inline-flex;height:16px;justify-content:center;width:16px}.bread-crumb.selected[_ngcontent-%COMP%]{border:4px solid #fff;box-shadow:0 5px 9px 0 rgba(0,0,0,.11);height:20px;width:20px}.bread-crumb.selected[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{display:none}.bread-crumb.selected[_ngcontent-%COMP%] ~ *[_ngcontent-%COMP%]{background:#dee7eb}.bread-crumb.selected[_ngcontent-%COMP%] ~ *[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{display:none}mat-icon[_ngcontent-%COMP%]{font-size:14px;height:14px;width:14px}.connector[_ngcontent-%COMP%]{background:linear-gradient(90deg,#6de1f7,#30b9da);height:3px;width:100px}", "@font-face{font-family:Inter;font-style:normal;font-weight:400;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Bold;font-style:normal;font-weight:700;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Semi Bold;font-style:normal;font-weight:500;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.p-8[_ngcontent-%COMP%]{padding:8px!important}.pt-8[_ngcontent-%COMP%]{padding-top:8px!important}.pb-8[_ngcontent-%COMP%]{padding-bottom:8px!important}.pl-8[_ngcontent-%COMP%]{padding-left:8px!important}.pr-8[_ngcontent-%COMP%]{padding-right:8px!important}.p-16[_ngcontent-%COMP%]{padding:16px!important}.pt-16[_ngcontent-%COMP%]{padding-top:16px!important}.pb-16[_ngcontent-%COMP%]{padding-bottom:16px!important}.pl-16[_ngcontent-%COMP%]{padding-left:16px!important}.pr-16[_ngcontent-%COMP%]{padding-right:16px!important}.m-0[_ngcontent-%COMP%]{margin:0!important}.mt-0[_ngcontent-%COMP%]{margin-top:0!important}.mb-0[_ngcontent-%COMP%]{margin-bottom:0!important}.ml-0[_ngcontent-%COMP%]{margin-left:0!important}.mr-0[_ngcontent-%COMP%]{margin-right:0!important}.m-8[_ngcontent-%COMP%]{margin:8px!important}.mt-8[_ngcontent-%COMP%]{margin-top:8px!important}.mb-8[_ngcontent-%COMP%]{margin-bottom:8px!important}.ml-8[_ngcontent-%COMP%]{margin-left:8px!important}.mr-8[_ngcontent-%COMP%]{margin-right:8px!important}.m-16[_ngcontent-%COMP%]{margin:16px!important}.mt-16[_ngcontent-%COMP%]{margin-top:16px!important}.mb-16[_ngcontent-%COMP%]{margin-bottom:16px!important}.ml-16[_ngcontent-%COMP%]{margin-left:16px!important}.mr-16[_ngcontent-%COMP%]{margin-right:16px!important}.m-24[_ngcontent-%COMP%]{margin:24px!important}.mt-24[_ngcontent-%COMP%]{margin-top:24px!important}.mb-24[_ngcontent-%COMP%]{margin-bottom:24px!important}.ml-24[_ngcontent-%COMP%]{margin-left:24px!important}.mr-24[_ngcontent-%COMP%]{margin-right:24px!important}.m-32[_ngcontent-%COMP%]{margin:32px!important}.mt-32[_ngcontent-%COMP%]{margin-top:32px!important}.mb-32[_ngcontent-%COMP%]{margin-bottom:32px!important}.ml-32[_ngcontent-%COMP%]{margin-left:32px!important}.mr-32[_ngcontent-%COMP%]{margin-right:32px!important}.m-40[_ngcontent-%COMP%]{margin:40px!important}.mt-40[_ngcontent-%COMP%]{margin-top:40px!important}.mb-40[_ngcontent-%COMP%]{margin-bottom:40px!important}.ml-40[_ngcontent-%COMP%]{margin-left:40px!important}.mr-40[_ngcontent-%COMP%]{margin-right:40px!important}.d-b[_ngcontent-%COMP%]{display:block!important}.d-ib[_ngcontent-%COMP%]{display:inline-block!important}.d-f[_ngcontent-%COMP%]{display:flex!important}.d-if[_ngcontent-%COMP%]{display:inline-flex!important}.d-g[_ngcontent-%COMP%]{display:grid!important}.d-n[_ngcontent-%COMP%]{display:none}.w-100[_ngcontent-%COMP%]{width:100%!important}.w-100vw[_ngcontent-%COMP%]{width:100vw!important}.h-100[_ngcontent-%COMP%]{height:100%!important}.h-100vh[_ngcontent-%COMP%]{height:100vh!important}.p-r[_ngcontent-%COMP%]{position:relative!important}.p-a[_ngcontent-%COMP%]{position:absolute!important}.p-f[_ngcontent-%COMP%]{position:fixed!important}.oy-a[_ngcontent-%COMP%]{overflow-y:auto}.f-1[_ngcontent-%COMP%]{flex:1!important}.fg-1[_ngcontent-%COMP%]{flex-grow:1!important}.fg-0[_ngcontent-%COMP%]{flex-grow:0!important}.fs-1[_ngcontent-%COMP%]{flex-shrink:1!important}.fs-0[_ngcontent-%COMP%]{flex-shrink:0!important}.fb-0[_ngcontent-%COMP%]{flex-basis:0!important}.fb-auto[_ngcontent-%COMP%]{flex-basis:auto!important}.ai-fs[_ngcontent-%COMP%]{align-items:flex-start!important}.ai-fe[_ngcontent-%COMP%]{align-items:flex-end!important}.ai-c[_ngcontent-%COMP%]{align-items:center!important}.fw-w[_ngcontent-%COMP%]{flex-wrap:wrap!important}.jc-c[_ngcontent-%COMP%]{justify-content:center!important}.jc-fe[_ngcontent-%COMP%]{justify-content:flex-end!important}.fd-c[_ngcontent-%COMP%]{flex-direction:column!important}.jc-sb[_ngcontent-%COMP%]{justify-content:space-between!important}.ta-l[_ngcontent-%COMP%]{text-align:left!important}.ta-c[_ngcontent-%COMP%]{text-align:center!important}.ta-r[_ngcontent-%COMP%]{text-align:right!important}.c-dewgong[_ngcontent-%COMP%]{color:#fff!important}.c-charmander[_ngcontent-%COMP%]{color:#ff7f7b!important}.c-amaura[_ngcontent-%COMP%]{color:#43bee6!important}.c-graveler[_ngcontent-%COMP%]{color:#647b83!important}.c-golem[_ngcontent-%COMP%]{color:#4f5868!important}.c-geodude[_ngcontent-%COMP%]{color:#91abb4!important}.c-snorlax[_ngcontent-%COMP%]{color:#818595!important}.c-steelix[_ngcontent-%COMP%]{color:#8b98ad!important}.fs-16[_ngcontent-%COMP%]{font-size:16px!important}.fs-14[_ngcontent-%COMP%]{font-size:14px!important}.fs-18[_ngcontent-%COMP%]{font-size:18px!important}.fs-24[_ngcontent-%COMP%]{font-size:24px!important}.fs-32[_ngcontent-%COMP%]{font-size:32px!important}.fw-bold[_ngcontent-%COMP%]{font-weight:700!important}.fw-semibold[_ngcontent-%COMP%]{font-weight:500!important}.c-pointer[_ngcontent-%COMP%]{cursor:pointer!important}.o-auto[_ngcontent-%COMP%]{overflow:auto!important}"] });
HorizontalStepperComponent.propDecorators = {
    showNav: [{ type: Input }],
    atBottom: [{ type: Input }],
    breadcrumbClicked: [{ type: Output }]
};
const ɵHorizontalStepperComponent_BaseFactory = /*@__PURE__*/ ɵngcc0.ɵɵgetInheritedFactory(HorizontalStepperComponent);
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HorizontalStepperComponent, [{
        type: Component,
        args: [{
                selector: 'livesafe-mat-horizontal-stepper',
                template: "<div class=\"d-f ai-c jc-c\" *ngIf=\"showNav\" [ngClass]=\"atBottom ? 'footer' : 'nav'\"s>\n  <ng-container *ngFor=\"let step of steps; let i = index\">\n    <div class=\"connector\" *ngIf=\"i > 0\"></div>\n    <div\n      tabindex=\"0\"\n      class=\"bread-crumb\"\n      [ngClass]=\"{ selected: selectedIndex === i }\"\n      (click)=\"selectedIndex = i; breadcrumbClicked.emit({ event: $event, index: i })\"\n      (keydown.enter)=\"selectedIndex = i\"\n      role=\"button\"\n      [attr.aria-label]=\"'navigate to step ' + (i + 1) + ', ' + step.label\"\n    >\n      <mat-icon class=\"c-dewgong\">check</mat-icon>\n    </div>\n  </ng-container>\n</div>\n\n<div class=\"body\">\n  <!-- Content from the CdkStep is projected here -->\n  <ng-container [ngTemplateOutlet]=\"selected?.stepLabel?.template\"></ng-container>\n  <ng-container [ngTemplateOutlet]=\"selected?.content\"></ng-container>\n</div>\n",
                providers: [{ provide: CdkStepper, useExisting: HorizontalStepperComponent }],
                styles: [":host{display:block}.nav{margin-bottom:40px}.footer{background-color:#fff;bottom:0;height:70px;left:0;margin-bottom:0;position:fixed;right:0;z-index:100}.bread-crumb{align-items:center;background:linear-gradient(90deg,#6de1f7,#30b9da);border-radius:100%;display:inline-flex;height:16px;justify-content:center;width:16px}.bread-crumb.selected{border:4px solid #fff;box-shadow:0 5px 9px 0 rgba(0,0,0,.11);height:20px;width:20px}.bread-crumb.selected mat-icon{display:none}.bread-crumb.selected~*{background:#dee7eb}.bread-crumb.selected~* mat-icon{display:none}mat-icon{font-size:14px;height:14px;width:14px}.connector{background:linear-gradient(90deg,#6de1f7,#30b9da);height:3px;width:100px}", "@font-face{font-family:Inter;font-style:normal;font-weight:400;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Bold;font-style:normal;font-weight:700;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}@font-face{font-family:Inter Semi Bold;font-style:normal;font-weight:500;src:url(/assets/fonts/Inter.ttf) format(\"truetype\")}.p-8{padding:8px!important}.pt-8{padding-top:8px!important}.pb-8{padding-bottom:8px!important}.pl-8{padding-left:8px!important}.pr-8{padding-right:8px!important}.p-16{padding:16px!important}.pt-16{padding-top:16px!important}.pb-16{padding-bottom:16px!important}.pl-16{padding-left:16px!important}.pr-16{padding-right:16px!important}.m-0{margin:0!important}.mt-0{margin-top:0!important}.mb-0{margin-bottom:0!important}.ml-0{margin-left:0!important}.mr-0{margin-right:0!important}.m-8{margin:8px!important}.mt-8{margin-top:8px!important}.mb-8{margin-bottom:8px!important}.ml-8{margin-left:8px!important}.mr-8{margin-right:8px!important}.m-16{margin:16px!important}.mt-16{margin-top:16px!important}.mb-16{margin-bottom:16px!important}.ml-16{margin-left:16px!important}.mr-16{margin-right:16px!important}.m-24{margin:24px!important}.mt-24{margin-top:24px!important}.mb-24{margin-bottom:24px!important}.ml-24{margin-left:24px!important}.mr-24{margin-right:24px!important}.m-32{margin:32px!important}.mt-32{margin-top:32px!important}.mb-32{margin-bottom:32px!important}.ml-32{margin-left:32px!important}.mr-32{margin-right:32px!important}.m-40{margin:40px!important}.mt-40{margin-top:40px!important}.mb-40{margin-bottom:40px!important}.ml-40{margin-left:40px!important}.mr-40{margin-right:40px!important}.d-b{display:block!important}.d-ib{display:inline-block!important}.d-f{display:flex!important}.d-if{display:inline-flex!important}.d-g{display:grid!important}.d-n{display:none}.w-100{width:100%!important}.w-100vw{width:100vw!important}.h-100{height:100%!important}.h-100vh{height:100vh!important}.p-r{position:relative!important}.p-a{position:absolute!important}.p-f{position:fixed!important}.oy-a{overflow-y:auto}.f-1{flex:1!important}.fg-1{flex-grow:1!important}.fg-0{flex-grow:0!important}.fs-1{flex-shrink:1!important}.fs-0{flex-shrink:0!important}.fb-0{flex-basis:0!important}.fb-auto{flex-basis:auto!important}.ai-fs{align-items:flex-start!important}.ai-fe{align-items:flex-end!important}.ai-c{align-items:center!important}.fw-w{flex-wrap:wrap!important}.jc-c{justify-content:center!important}.jc-fe{justify-content:flex-end!important}.fd-c{flex-direction:column!important}.jc-sb{justify-content:space-between!important}.ta-l{text-align:left!important}.ta-c{text-align:center!important}.ta-r{text-align:right!important}.c-dewgong{color:#fff!important}.c-charmander{color:#ff7f7b!important}.c-amaura{color:#43bee6!important}.c-graveler{color:#647b83!important}.c-golem{color:#4f5868!important}.c-geodude{color:#91abb4!important}.c-snorlax{color:#818595!important}.c-steelix{color:#8b98ad!important}.fs-16{font-size:16px!important}.fs-14{font-size:14px!important}.fs-18{font-size:18px!important}.fs-24{font-size:24px!important}.fs-32{font-size:32px!important}.fw-bold{font-weight:700!important}.fw-semibold{font-weight:500!important}.c-pointer{cursor:pointer!important}.o-auto{overflow:auto!important}"]
            }]
    }], null, { showNav: [{
            type: Input
        }], atBottom: [{
            type: Input
        }], breadcrumbClicked: [{
            type: Output
        }] }); })();

class LiveSafeMatDirective {
    constructor(el) {
        el.nativeElement.classList.add('livesafe-mat');
    }
}
LiveSafeMatDirective.ɵfac = function LiveSafeMatDirective_Factory(t) { return new (t || LiveSafeMatDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
LiveSafeMatDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: LiveSafeMatDirective, selectors: [["", "livesafeMat", ""]] });
LiveSafeMatDirective.ctorParameters = () => [
    { type: ElementRef }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveSafeMatDirective, [{
        type: Directive,
        args: [{
                selector: '[livesafeMat]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class StepperRoutingDirective {
    constructor(host, router, route) {
        this.host = host;
        this.router = router;
        this.route = route;
        this.stepRouteFragment$ = this.route.fragment;
        this.unsubscribe = new Subject();
    }
    ngAfterViewInit() {
        this.initRouting();
    }
    ngOnDestroy() {
        // Remove route fragment
        this.router.navigate(this.route.snapshot.url, {
            fragment: undefined
        });
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
    initRouting() {
        // Set the route fragment to the first step
        this.router.navigate(this.route.snapshot.url, {
            fragment: this.host.steps.first.label,
            preserveFragment: false,
            queryParams: this.route.snapshot.queryParams
        });
        // Set the route fragment as steps change
        this.host.selectionChange.subscribe((step) => {
            this.router.navigate(this.route.snapshot.url, {
                fragment: step.selectedStep.label,
                preserveFragment: false,
                queryParams: this.route.snapshot.queryParams
            });
        });
        // Watch route fragment changes
        this.stepRouteFragment$.pipe(takeUntil(this.unsubscribe)).subscribe((step) => {
            this.selectStep(step);
        });
    }
    selectStep(stepLabel) {
        const selectedStep = this.host.steps.find((_step) => _step.label === stepLabel);
        if (selectedStep) {
            selectedStep.select();
        }
    }
    onSelectStep(index) {
        this.host.selectedIndex = index;
    }
}
StepperRoutingDirective.ɵfac = function StepperRoutingDirective_Factory(t) { return new (t || StepperRoutingDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.CdkStepper), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.ActivatedRoute)); };
StepperRoutingDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: StepperRoutingDirective, selectors: [["", "livesafeMatStepperRouting", ""]] });
StepperRoutingDirective.ctorParameters = () => [
    { type: CdkStepper },
    { type: Router },
    { type: ActivatedRoute }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepperRoutingDirective, [{
        type: Directive,
        args: [{
                selector: '[livesafeMatStepperRouting]'
            }]
    }], function () { return [{ type: ɵngcc5.CdkStepper }, { type: ɵngcc6.Router }, { type: ɵngcc6.ActivatedRoute }]; }, null); })();

class LiveSafeMatIconRegistry {
    constructor($matIconRegistry, $domSanitizer) {
        this.$matIconRegistry = $matIconRegistry;
        this.$domSanitizer = $domSanitizer;
        this.$matIconRegistry.setDefaultFontSetClass('material-icons-round');
    }
    initSvgs(svgFilenames, pathToSvgFiles) {
        if (pathToSvgFiles.endsWith('/')) {
            pathToSvgFiles.substring(0, pathToSvgFiles.length - 1);
        }
        svgFilenames.forEach((svgFilename) => {
            this.$matIconRegistry.addSvgIcon(svgFilename, this.$domSanitizer.bypassSecurityTrustResourceUrl(`${pathToSvgFiles}/${svgFilename}.svg`));
        });
    }
}
LiveSafeMatIconRegistry.ɵfac = function LiveSafeMatIconRegistry_Factory(t) { return new (t || LiveSafeMatIconRegistry)(ɵngcc0.ɵɵinject(ɵngcc4.MatIconRegistry), ɵngcc0.ɵɵinject(ɵngcc7.DomSanitizer)); };
LiveSafeMatIconRegistry.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LiveSafeMatIconRegistry, factory: LiveSafeMatIconRegistry.ɵfac });
LiveSafeMatIconRegistry.ctorParameters = () => [
    { type: MatIconRegistry },
    { type: DomSanitizer }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveSafeMatIconRegistry, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc4.MatIconRegistry }, { type: ɵngcc7.DomSanitizer }]; }, null); })();

const MATERIAL_MODULES = [
    A11yModule,
    CdkStepperModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatPaginatorModule,
    MatPasswordStrengthModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTooltipModule
];
const ɵ0 = {
    duration: 8000,
    panelClass: ['livesafe-mat'],
    politeness: 'assertive'
}, ɵ1 = {
    hasBackdrop: true,
    autoFocus: true,
    restoreFocus: true,
    panelClass: ['livesafe-mat']
}, ɵ2 = {
    expandedHeight: '0px',
    hideToggle: true
};
class LiveSafeMaterialModule {
}
LiveSafeMaterialModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LiveSafeMaterialModule });
LiveSafeMaterialModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LiveSafeMaterialModule_Factory(t) { return new (t || LiveSafeMaterialModule)(); }, providers: [
        LiveSafeMatIconRegistry,
        {
            provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
            useValue: ɵ0
        },
        {
            provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
            useValue: ɵ1
        },
        {
            provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
            useValue: ɵ2
        }
    ], imports: [[CommonModule, MATERIAL_MODULES], A11yModule,
        CdkStepperModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatPasswordStrengthModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTooltipModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(LiveSafeMaterialModule, { declarations: function () { return [LiveSafeMatDirective, StepperRoutingDirective, CustomSnackbarComponent, HorizontalStepperComponent]; }, imports: function () { return [CommonModule, A11yModule,
        CdkStepperModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatPasswordStrengthModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTooltipModule]; }, exports: function () { return [A11yModule,
        CdkStepperModule,
        MatAutocompleteModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatPaginatorModule,
        MatPasswordStrengthModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatSortModule,
        MatStepperModule,
        MatTableModule,
        MatTooltipModule, LiveSafeMatDirective, StepperRoutingDirective, CustomSnackbarComponent, HorizontalStepperComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LiveSafeMaterialModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    LiveSafeMatDirective,
                    StepperRoutingDirective,
                    CustomSnackbarComponent,
                    HorizontalStepperComponent
                ],
                imports: [CommonModule, MATERIAL_MODULES],
                exports: [
                    ...MATERIAL_MODULES,
                    LiveSafeMatDirective,
                    StepperRoutingDirective,
                    CustomSnackbarComponent,
                    HorizontalStepperComponent
                ],
                providers: [
                    LiveSafeMatIconRegistry,
                    {
                        provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
                        useValue: ɵ0
                    },
                    {
                        provide: MAT_BOTTOM_SHEET_DEFAULT_OPTIONS,
                        useValue: ɵ1
                    },
                    {
                        provide: MAT_EXPANSION_PANEL_DEFAULT_OPTIONS,
                        useValue: ɵ2
                    }
                ]
            }]
    }], null, null); })();

/**
 * A helper service to open Material bottom sheets
 * with our custom designs and configuration.
 */
class BottomSheetService {
    constructor(bottomSheet) {
        this.bottomSheet = bottomSheet;
        this.defaultConfig = {
            hasBackdrop: true,
            autoFocus: true,
            restoreFocus: true,
            panelClass: ['livesafe-mat']
        };
    }
    open(component, warn = false) {
        const config = warn
            ? Object.assign(Object.assign({}, this.defaultConfig), { panelClass: ['livesafe-mat', 'warn'] })
            : this.defaultConfig;
        this.bottomSheet.open(component, config);
    }
}
BottomSheetService.ɵfac = function BottomSheetService_Factory(t) { return new (t || BottomSheetService)(ɵngcc0.ɵɵinject(ɵngcc8.MatBottomSheet)); };
BottomSheetService.ɵprov = ɵɵdefineInjectable({ factory: function BottomSheetService_Factory() { return new BottomSheetService(ɵɵinject(MatBottomSheet)); }, token: BottomSheetService, providedIn: "root" });
BottomSheetService.ctorParameters = () => [
    { type: MatBottomSheet }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(BottomSheetService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc8.MatBottomSheet }]; }, null); })();

/**
 *  A helper service to open Material snack bars
 *  with our custom designs and configurations.
 */
class SnackbarService {
    constructor(router, snackbar) {
        this.router = router;
        this.snackbar = snackbar;
        this.timeoutMs = 8000;
        this.clearOnNavigation = true;
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationStart && this.clearOnNavigation) {
                this.clear();
            }
        });
    }
    error(message, persistent = false, clearOnNavigation = true, aboveFooter = false, isDismissibile = true) {
        return this.alert(AlertType.Error, message, persistent, clearOnNavigation, aboveFooter, isDismissibile);
    }
    info(message, persistent = false, clearOnNavigation = true, aboveFooter = false, isDismissibile = true) {
        return this.alert(AlertType.Info, message, persistent, clearOnNavigation, aboveFooter, isDismissibile);
    }
    warn(message, persistent = false, clearOnNavigation = true, aboveFooter = false, isDismissibile = true) {
        return this.alert(AlertType.Warn, message, persistent, clearOnNavigation, aboveFooter, isDismissibile);
    }
    clear() {
        this.snackbar.dismiss();
    }
    alert(type, message, persistent = false, clearOnNavigation = true, aboveFooter = false, isDismissible = true) {
        const duration = persistent ? undefined : this.timeoutMs;
        const data = duration
            ? {
                type,
                message,
                isDismissible,
                duration
            }
            : {
                type,
                message,
                isDismissible
            };
        const config = {
            duration,
            panelClass: aboveFooter ? ['livesafe-mat', 'aboveFooter'] : ['livesafe-mat'],
            politeness: 'assertive',
            data
        };
        this.clearOnNavigation = clearOnNavigation;
        return this.snackbar.openFromComponent(CustomSnackbarComponent, config);
    }
}
SnackbarService.ɵfac = function SnackbarService_Factory(t) { return new (t || SnackbarService)(ɵngcc0.ɵɵinject(ɵngcc6.Router), ɵngcc0.ɵɵinject(ɵngcc1.MatSnackBar)); };
SnackbarService.ɵprov = ɵɵdefineInjectable({ factory: function SnackbarService_Factory() { return new SnackbarService(ɵɵinject(Router), ɵɵinject(MatSnackBar)); }, token: SnackbarService, providedIn: "root" });
SnackbarService.ctorParameters = () => [
    { type: Router },
    { type: MatSnackBar }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(SnackbarService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc6.Router }, { type: ɵngcc1.MatSnackBar }]; }, null); })();

class OverlayService {
    constructor(injector, overlay, focusTrapFactory) {
        this.injector = injector;
        this.overlay = overlay;
        this.focusTrapFactory = focusTrapFactory;
        this.defaultConfig = {
            positionStrategy: this.overlay.position().global(),
            scrollStrategy: this.overlay.scrollStrategies.noop(),
            panelClass: 'livesafe-mat',
            disposeOnNavigation: true
        };
        this.overlays = new WeakMap();
    }
    /**
     * Creates an overlay with the provided component. Applies default LiveSafe configurations and puts a focus trap on the component
     * @param component
     * @param inputs
     * @param config
     */
    open(component, inputs, config = {}) {
        const overlayConfig = Object.assign(Object.assign({}, this.defaultConfig), config);
        const overlayRef = this.overlay.create(overlayConfig);
        const portal = new ComponentPortal(component, null, this.createOverlayRefInjector(overlayRef));
        const componentRef = overlayRef.attach(portal);
        Object.assign(componentRef.instance, inputs);
        this.focusTrapFactory.create(overlayRef.overlayElement);
        if (!this.overlays.get(component)) {
            this.overlays.set(component, overlayRef);
        }
        return overlayRef;
    }
    /**
     * Closes the overlay associated with the component
     * @param component Component class
     */
    close(component) {
        const overlayRef = this.overlays.get(component);
        if (overlayRef) {
            overlayRef.dispose();
            this.overlays.delete(component);
        }
    }
    createOverlayRefInjector(overlayRef) {
        const injectionTokens = new WeakMap();
        injectionTokens.set(OverlayRef, overlayRef);
        return new PortalInjector(this.injector, injectionTokens);
    }
}
OverlayService.ɵfac = function OverlayService_Factory(t) { return new (t || OverlayService)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ɵngcc9.Overlay), ɵngcc0.ɵɵinject(ɵngcc10.FocusTrapFactory)); };
OverlayService.ɵprov = ɵɵdefineInjectable({ factory: function OverlayService_Factory() { return new OverlayService(ɵɵinject(INJECTOR), ɵɵinject(Overlay), ɵɵinject(FocusTrapFactory)); }, token: OverlayService, providedIn: "root" });
OverlayService.ctorParameters = () => [
    { type: Injector },
    { type: Overlay },
    { type: FocusTrapFactory }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(OverlayService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ɵngcc9.Overlay }, { type: ɵngcc10.FocusTrapFactory }]; }, null); })();

/*
 * Public API Surface of material
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Alert, AlertType, BottomSheetService, CustomSnackbarComponent, HorizontalStepperComponent, LiveSafeMatDirective, LiveSafeMatIconRegistry, LiveSafeMaterialModule, OverlayService, SnackbarService, StepperRoutingDirective };

//# sourceMappingURL=livesafe-material.js.map